import axios from 'axios';
import { API_BASE_URL } from '../config';

// Public API instance for endpoints that don't require authentication (but still passes token if available)
const publicApi = axios.create({
  baseURL: API_BASE_URL
});

// Request interceptor to add auth token even to public calls if it exists
publicApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

publicApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.log('Public API - 401 Unauthorized');
    }
    return Promise.reject(error);
  }
);

export const publicOrderAPI = {
  createOrder: (formData) => {
    if (!(formData instanceof FormData)) {
      console.error('Expected FormData but received:', typeof formData);
      throw new Error('FormData required for order creation');
    }

    return publicApi.post('/orders', formData);
  },
  
  submitRefund: (formData) => {
    if (!(formData instanceof FormData)) {
      throw new Error('FormData required for refund submission');
    }
    const config = {
      transformRequest: [(data, headers) => {
        delete headers['Content-Type'];
        return data;
      }]
    };
    
    return publicApi.post('/orders/refund', formData, config);
  },
};

export default publicApi;
